var map = {
	"./gcgmonash.png": 220,
	"./minter.png": 221,
	"./monash.png": 222,
	"./swinburne.png": 223,
	"./sylaba.png": 224,
	"./techfugees.png": 225,
	"./yc.png": 226,
	"./ygap.png": 227
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 355;